/* Important Info component on the CharactersAdd component
   telling users how to add Characters */
import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../../../styles/Scene.module.css";

const InfoChar = () => {
  return (
    <div>
    <Row className="mb-3">
      <Col className="d-none d-md-block" md={1}></Col>     
      <Col xs={12} md={10} >
        <div className={`px-3 py-2 ${styles.SubTitle6 }`}>
          <p className={`${styles.Red} text-center`}>CHARACTERS & BG/STAND-INS</p>
          <hr className={`mt-2 mb-0`}/>
            <p className={`pt-2`}><span className={`${styles.Red}`}>*</span> Click the <span className={`${styles.Red}`}> Add Scene Character</span> tab to add the 
          Scene's Characters from the dropdown which contains all previously added Project Characters.
          </p>
        <p className={`pt-2`}><span className={`${styles.Red}`}>*</span> New Project Characters can be created here by clicking
            the <span className={`${styles.Red}`}> Add New Characters</span> tab
          or in the Characters section.</p>
          <p className={`pt-2`}><span className={`${styles.Red}`}>*</span> The <span className={`${styles.Red}`}>Wardrobe Department</span> can 
          use a Character's Edit button to Add/Update the Character's Costume.</p>
          <p className={`pt-4`}><span className={`${styles.Red}`}>*</span> Add Background/Stand-in items using the <span className={`${styles.Red}`}>Add BG/Stand-ins</span> tab
          and use the Edit button to Update an item. 
          </p>
            <hr className={`mt-2 mb-0`}/>
         </div>
      </Col>
    </Row>
    </div>
  )
}

export default InfoChar